<template>
  <div class='h100vh-100'>
    <!-- 非实时任务工具栏 -->
    <PmNoRealTaskRightListToolbar :taskStatus="taskStatus"></PmNoRealTaskRightListToolbar>

    <!-- 非实时任务列表 -->
    <PmNoRealTaskRightListContent @taskStatusChange="taskStatusChange" ref="pmNoRealTaskRightListContent" :queryParamsForResourceTreeClick="queryParamsForResourceTreeClick"></PmNoRealTaskRightListContent>

    <!-- 创建非实时任务第一步弹出框 -->
    <CustomDialog ref='createTaskDialog1' :element='createTaskDialog1.element' :styles='createTaskDialog1.style'>
      <template v-slot:dialog-content>
        <CreateNoRealTaskDialog1 ref='createNoRealTaskDialog1'></CreateNoRealTaskDialog1>
      </template>
    </CustomDialog>

    <!-- 创建非实时任务第一步弹出框 -->
    <CustomDialog ref='createTaskDialog2' :element='createNoRealTaskDialog2.element' :styles='createNoRealTaskDialog2.style'>
      <template v-slot:dialog-content>
        <CreateNoRealTaskDialog2 ref='createNoRealTaskDialog2' :paramsOfNoRealTaskCreateDialog1="paramsOfNoRealTaskCreateDialog1"></CreateNoRealTaskDialog2>
      </template>
    </CustomDialog>

    <!-- 修改非实时任务第一步弹出框 -->
    <CustomDialog ref='modifyTaskDialog1' :element='modifyNoRealTaskDialog1.element' :styles='modifyNoRealTaskDialog1.style'>
      <template v-slot:dialog-content>
        <ModifyNoRealTaskDialog1 ref='modifyNoRealTaskDialog1'></ModifyNoRealTaskDialog1>
      </template>
    </CustomDialog>

    <!-- 修改非实时任务第一步弹出框 -->
    <CustomDialog ref='modifyTaskDialog2' :element='modifyNoRealTaskDialog2.element' :styles='modifyNoRealTaskDialog2.style'>
      <template v-slot:dialog-content>
        <ModifyNoRealTaskDialog2 ref='modifyNoRealTaskDialog2'></ModifyNoRealTaskDialog2>
      </template>
    </CustomDialog>

    <!-- 补采任务弹出框 -->
    <CustomDialog ref='uploadTaskDialog' :element='uploadNoRealTaskDialog.element' :styles='uploadNoRealTaskDialog.style'>
      <template v-slot:dialog-content>
        <UploadNoRealTaskDialog ref='uploadNoRealTaskDialog'></UploadNoRealTaskDialog>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import PmNoRealTaskRightListToolbar from './PmNoRealTaskRightListToolbar';
import PmNoRealTaskRightListContent from './PmNoRealTaskRightListContent';
import CreateNoRealTaskDialog1 from './dialog/CreateNoRealTaskDialog1';
import CreateNoRealTaskDialog2 from './dialog/CreateNoRealTaskDialog2';
import ModifyNoRealTaskDialog1 from './dialog/ModifyNoRealTaskDialog1';
import ModifyNoRealTaskDialog2 from './dialog/ModifyNoRealTaskDialog2';
import UploadNoRealTaskDialog from './dialog/UploadNoRealTaskDialog';
import CustomDialog from '../../../../common/CustomDialog';
import {EventBus} from "../../../../../plugins/eventBus";

export default {
  name: 'PmNoRealTaskRightList',
  props: [
    'queryParamsForResourceTreeClick',
  ],
  components: {
    PmNoRealTaskRightListToolbar,
    PmNoRealTaskRightListContent,
    CreateNoRealTaskDialog1,
    CreateNoRealTaskDialog2,
    ModifyNoRealTaskDialog1,
    ModifyNoRealTaskDialog2,
    UploadNoRealTaskDialog,
    CustomDialog,
  },
  data() {
    return {
      // 添加非实时任务第一步弹出框配置信息
      createTaskDialog1: {
        style: {
          width: '800px',
          height: '688px',
          visible: false,
          model: true
        },
        element: {
          title: `${this.$t('Pm.establishTask')}：${this.$t('Pm.first')}`,
          target: this.$refs.pmNoRealTaskRightListContent,
          refName: 'createTaskElement',
          buttonGroup: [
            { click: this.closeCreateNoRealTaskDialog1, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.nextForCreateNoRealTask, buttonModel: { content: this.$t('Pm.nextStep') } }
          ],
          isClose: true
        }
      },

      // 添加非实时任务第二步弹出框配置信息
      createNoRealTaskDialog2: {
        style: {
          width: '800px',
          height: '688px',
          visible: false,
          model: true
        },
        element: {
          title: `${this.$t('Pm.establishTask')}：${this.$t('Pm.second')}`,
          target: this.$refs.pmNoRealTaskRightListContent,
          refName: 'createTaskElement',
          buttonGroup: [
            { click: this.closeCreateNoRealTaskDialog2, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.preForCreateNoRealTask, buttonModel: { content: this.$t('Pm.preStep') } },
            { click: this.completeCreateNoRealTask, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
          ],
          isClose: true
        }
      },

      // 修改非实时任务第一步弹出框配置信息
      modifyNoRealTaskDialog1: {
        style: {
          width: '800px',
          height: '688px',
          visible: false,
          model: true
        },
        element: {
          title: `${this.$t('Pm.modifyTask')}：${this.$t('Pm.first')}`,
          target: this.$refs.pmNoRealTaskRightListContent,
          refName: 'modifyTaskElement',
          buttonGroup: [
            { click: this.closeModifyNoRealTaskDialog1, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.nextForModifyNoRealTask, buttonModel: { content: this.$t('Pm.nextStep') } }
          ],
          isClose: true
        }
      },

      // 修改非实时任务第二步弹出框配置信息
      modifyNoRealTaskDialog2: {
        style: {
          width: '800px',
          height: '688px',
          visible: false,
          model: true
        },
        element: {
          title: `${this.$t('Pm.modifyTask')}：${this.$t('Pm.second')}`,
          target: this.$refs.pmNoRealTaskRightListContent,
          refName: 'modifyTaskElement',
          buttonGroup: [
            { click: this.closeModifyNoRealTaskDialog2, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.preForModifyNoRealTask, buttonModel: { content: this.$t('Pm.preStep') } },
            { click: this.completeModifyNoRealTask, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
          ],
          isClose: true
        }
      },

      // 修改非实时任务第二步弹出框配置信息
      uploadNoRealTaskDialog: {
        style: {
          width: '600px',
          height: '400px',
          visible: false,
          model: true
        },
        element: {
          title: this.$t('Pm.taskUploadSetting'),
          target: this.$refs.pmNoRealTaskRightListContent,
          refName: 'uploadTaskElement',
          buttonGroup: [
            { click: this.closeUploadNoRealTaskDialog, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.uploadNoRealTask, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
          ],
          isClose: true
        }
      },
      paramsOfNoRealTaskCreateDialog1: {},
      paramsOfNoRealTaskCreateDialog2: {},
      paramsOfNoRealTaskModifyDialog1: {},
      paramsOfNoRealTaskModifyDialog2: {},
      selectNeType: 0, // 步骤一种选择的网元类型
      selectCycle: 0,  // 步骤一种选择的测量周期
      uploadGridClickData: {},
      taskStatus: 3,
      editTaskId: 0
    };
  },
  methods: {
    taskStatusChange(msg) {
      this.taskStatus = msg;
    },

    // 根据工具栏组件穿过来的值分发到相应的任务并执行
    methodList(operator) {
      switch (operator) {
        case 'create':
          this.createTask();
          break;
        case 'modify':
          this.modifyTask();
          break;
        case 'delete':
          this.deleteTask();
          break;
        case 'hungUp':
          this.hungUpTask();
          break;
        case 'active':
          this.activeTask();
          break;
        case 'upload':
          this.uploadTask();
          break;
        case 'reset':
          this.resetTask();
          break;
        case 'consistency':
          this.checkTaskConsistency();
          break;
        case 'sync':
          this.syncTask();
          break;
        case 'detail':
          this.showTaskDetail();
          break;
        default:
      }
    },
    createTask(){
      this.$refs.createNoRealTaskDialog1.bindValidateOfCreateDialog1();
      this.$refs.createTaskDialog1.show();
    },
    modifyTask(){
      const data = this.$refs.pmNoRealTaskRightListContent.rowDataOfPmNoRealTaskList;
      this.$refs.modifyNoRealTaskDialog1.bindValidateOfModifyDialog1();
      this.editTaskId = data.taskId;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }

      if(data.week != null){
        this.$refs.modifyNoRealTaskDialog1.$refs.radioPlanWeek.click();
        this.$refs.modifyNoRealTaskDialog1.weekDayExistIndexList = data.week.split(",").map(item => {
          if(item == '0'){
            return 6;
          }
          return +item - 1;
        });
      } else if (data.day != null){
        this.$refs.modifyNoRealTaskDialog1.$refs.radioPlanMonth.click();
        this.$refs.modifyNoRealTaskDialog1.monthDayExistIndexList = data.day.split(",").map(item => {
          return +item - 1;
        });
      } else {
        this.$refs.modifyNoRealTaskDialog1.$refs.radioPlanNone.click();
      }

      this.$refs.modifyNoRealTaskDialog1.paramsOfNoRealTaskModifyDialog1 = {
          taskName: data.taskName,
          taskDepict: data.taskDepict,
          neType: data.neType + '',
          sampleTime: data.sampleTime,
          reportTime: data.reportTime,
          startTime: new Date(data.startTime * 1000),
          endTime: data.endTime == null ? null : new Date(data.endTime * 1000),
          startHour: data.startHour == null ? -1 : data.startHour,
          endHour: data.endHour == null ? -1 : data.endHour,
          week: data.week == null ? [] : data.week.split(","),
          day: data.day == null ? [] : data.day.split(",")
      };

      this.$refs.modifyTaskDialog1.show();
    },
    async deleteTask(){
      const data = this.$refs.pmNoRealTaskRightListContent.rowDataOfPmNoRealTaskList;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.$loading.showLoadding(this.$t('System.loading'));
      await this.$axios.post('/lte/ems/pm/noReal/task/deleteNoRealTask.html', data).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.deleteTask')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmNoRealTaskRightListContent.getTaskListOfPmNoReal();
        this.$parent.$parent.$refs.PmNoRealTaskLeftTree.$refs.PmNoRealTaskResourceTreePage.getNeTree();
      });
      this.$loading.hideLoadding();
    },
    async hungUpTask(){
      const data = this.$refs.pmNoRealTaskRightListContent.rowDataOfPmNoRealTaskList;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.$loading.showLoadding(this.$t('System.loading'));
      await this.$axios.post('/lte/ems/pm/noReal/task/hangUpNoRealTask.html', data).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.hangup')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmNoRealTaskRightListContent.getTaskListOfPmNoReal();
        this.$parent.$parent.$refs.PmNoRealTaskLeftTree.$refs.PmNoRealTaskResourceTreePage.getNeTree();
      });
      this.$loading.hideLoadding();
    },
    async activeTask(){
      const data = this.$refs.pmNoRealTaskRightListContent.rowDataOfPmNoRealTaskList;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.$loading.showLoadding(this.$t('System.loading'));
      await this.$axios.post('/lte/ems/pm/noReal/task/activeNoRealTask.html', data).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.active')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmNoRealTaskRightListContent.getTaskListOfPmNoReal();
        this.$parent.$parent.$refs.PmNoRealTaskLeftTree.$refs.PmNoRealTaskResourceTreePage.getNeTree();
      });
      this.$loading.hideLoadding();
    },
    uploadTask(){
      const data = this.$refs.pmNoRealTaskRightListContent.rowDataOfPmNoRealTaskList;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.uploadGridClickData = data;

      this.$refs.uploadNoRealTaskDialog.bindValidateOfUploadDialog();
      this.$refs.uploadTaskDialog.show();
    },
    async resetTask(){
      const data = this.$refs.pmNoRealTaskRightListContent.rowDataOfPmNoRealTaskList;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.$loading.showLoadding(this.$t('System.loading'));
      await this.$axios.post('/lte/ems/pm/noReal/task/resetNoRealTask.html', data).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.reset')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmNoRealTaskRightListContent.getTaskListOfPmNoReal();
        this.$parent.$parent.$refs.PmNoRealTaskLeftTree.$refs.PmNoRealTaskResourceTreePage.getNeTree();
      });
      this.$loading.hideLoadding();
    },
    async checkTaskConsistency(){
      const data = this.$refs.pmNoRealTaskRightListContent.rowDataOfPmNoRealTaskList;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.$loading.showLoadding(this.$t('System.loading'));
      await this.$axios.post('/lte/ems/pm/noReal/task/checkNoRealTaskConsistency.html', data).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.consistencyQuery')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmNoRealTaskRightListContent.getTaskListOfPmNoReal();
        this.$parent.$parent.$refs.PmNoRealTaskLeftTree.$refs.PmNoRealTaskResourceTreePage.getNeTree();
      });
      this.$loading.hideLoadding();
    },
    async syncTask(){
      const data = this.$refs.pmNoRealTaskRightListContent.rowDataOfPmNoRealTaskList;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.$loading.showLoadding(this.$t('System.loading'));
      await this.$axios.post('/lte/ems/pm/noReal/task/syncNoRealTask.html', data).then(response => {
        if(response.data.errorCode == null){
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.unknownError') });
        }else if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.syncTask')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmNoRealTaskRightListContent.getTaskListOfPmNoReal();
        this.$parent.$parent.$refs.PmNoRealTaskLeftTree.$refs.PmNoRealTaskResourceTreePage.getNeTree();
      });
      this.$loading.hideLoadding();
    },
    showTaskDetail(){
      const data = this.$refs.pmNoRealTaskRightListContent.rowDataOfPmNoRealTaskList;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
    },

    // 关闭创建非实时任务第一步弹出框
    closeCreateNoRealTaskDialog1() {
      this.$refs.createTaskDialog1.close();
    },

    // 创建非实时任务下一步
    nextForCreateNoRealTask(){
      const ruleDatas = this.$refs.createNoRealTaskDialog1.validateOfCreateDialog1();
      if (!ruleDatas) {
        return;
      }
      this.paramsOfNoRealTaskCreateDialog1 = this.$refs.createNoRealTaskDialog1.paramsOfNoRealTaskCreateDialog1;
      this.selectNeType = this.paramsOfNoRealTaskCreateDialog1.neType;
      this.selectCycle = this.paramsOfNoRealTaskCreateDialog1.sampleTime;
      this.$refs.createNoRealTaskDialog2.$refs.NeTreeForNoRealTaskCreate.getResourceTreeForNoRealTaskCreate(this.selectNeType,this.selectCycle);
      this.$refs.createTaskDialog1.close();
      this.$refs.createTaskDialog2.show();
    },

    // 关闭创建非实时任务第二步弹出框
    closeCreateNoRealTaskDialog2() {
      this.$refs.createTaskDialog2.close();
    },

    // 创建非实时任务上一步
    preForCreateNoRealTask(){
      this.$refs.createNoRealTaskDialog1.paramsOfNoRealTaskCreateDialog1 = this.paramsOfNoRealTaskCreateDialog1;
      this.$refs.createNoRealTaskDialog1.bindValidateOfCreateDialog1();
      this.$refs.createTaskDialog2.close();
      this.$refs.createTaskDialog1.show();
    },

    // 完成创建非实时任务
    async completeCreateNoRealTask() {
      let tipsShow = this.$refs.createNoRealTaskDialog2.$refs.MeasureTreeForNoRealTaskCreate.tipsShow;
      if(tipsShow){
        let text = this.$refs.createNoRealTaskDialog2.$refs.MeasureTreeForNoRealTaskCreate.text;
        EventBus.$emit('toast', { type: 'warning', content: text });
        return;
      }

      this.paramsOfNoRealTaskCreateDialog2 = this.$refs.createNoRealTaskDialog2.paramsOfNoRealTaskCreateDialog2;
      const counterIdList = this.paramsOfNoRealTaskCreateDialog2.counterIdList.map(function (counterId) {
        const index = counterId.search(/[1-9]/);
        return counterId.slice(index);
      });
      const counterObjList = this.$refs.createNoRealTaskDialog2.treeGridList.filter(function (counterObj) {
        return counterObj.parentItem != null;
      }).map(function (counterObj) {
        return {
          counterName: counterObj.counterName,
          counterCode: counterObj.id,
          measureObjName: counterObj.measureObjName,
          taskMeasureObjCode: counterObj.parentItem
        }
      });
      this.$loading.showLoadding(this.$t('System.loading'));

      await this.$axios.post('/lte/ems/pm/noReal/task/createNoRealTask.html', {
        taskName: this.paramsOfNoRealTaskCreateDialog1.taskName,
        taskDepict: this.paramsOfNoRealTaskCreateDialog1.taskDepict,
        neType: parseInt(this.paramsOfNoRealTaskCreateDialog1.neType),
        sampleTime: parseInt(this.paramsOfNoRealTaskCreateDialog1.sampleTime),
        reportTime: parseInt(this.paramsOfNoRealTaskCreateDialog1.reportTime),
        startTime: parseInt(this.paramsOfNoRealTaskCreateDialog1.startTime == null ? '0' : this.paramsOfNoRealTaskCreateDialog1.startTime.getTime() / 1000),
        endTime: parseInt(this.paramsOfNoRealTaskCreateDialog1.endTime == null ? '0' : this.paramsOfNoRealTaskCreateDialog1.endTime.getTime() / 1000),
        startHour: parseInt(this.paramsOfNoRealTaskCreateDialog1.startHour),
        endHour: parseInt(this.paramsOfNoRealTaskCreateDialog1.endHour),
        week: this.paramsOfNoRealTaskCreateDialog1.week.join(),
        day: this.paramsOfNoRealTaskCreateDialog1.day.join(),
        neId: parseInt(this.paramsOfNoRealTaskCreateDialog2.neId),
        counterIdNum: parseInt(this.paramsOfNoRealTaskCreateDialog2.counterIdNum),
        counterIdList: counterIdList.join(),
        counterObjList: JSON.stringify(counterObjList)
      }).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode.toUpperCase() != 'SUCCESS') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.createPmTask')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmNoRealTaskRightListContent.getTaskListOfPmNoReal();
        this.$parent.$parent.$refs.PmNoRealTaskLeftTree.$refs.PmNoRealTaskResourceTreePage.getNeTree();
      });
      this.$loading.hideLoadding();
      this.$refs.createTaskDialog2.close();
    },

    // 关闭修改非实时任务第一步弹出框
    closeModifyNoRealTaskDialog1() {
      this.$refs.modifyTaskDialog1.close();
    },

    // 修改非实时任务下一步
    nextForModifyNoRealTask(){
      console.log("aa");

      const ruleDatas = this.$refs.modifyNoRealTaskDialog1.validateOfModifyDialog1();

      console.log(ruleDatas);
      if (!ruleDatas) {
        return;
      }

      this.paramsOfNoRealTaskModifyDialog1 = this.$refs.modifyNoRealTaskDialog1.paramsOfNoRealTaskModifyDialog1;
      this.selectNeType = this.paramsOfNoRealTaskModifyDialog1.neType;
      this.selectCycle = this.paramsOfNoRealTaskModifyDialog1.sampleTime;
      this.$refs.modifyNoRealTaskDialog2.$refs.NeTreeForNoRealTaskModify.getResourceTreeForNoRealTaskModify(this.selectNeType,this.selectCycle);
      this.$refs.modifyTaskDialog1.close();
      this.$refs.modifyTaskDialog2.show();
    },

    // 关闭修改非实时任务第二步弹出框
    closeModifyNoRealTaskDialog2() {
      this.$refs.modifyTaskDialog2.close();
    },

    // 修改非实时任务上一步
    preForModifyNoRealTask(){
      this.$refs.modifyNoRealTaskDialog1.paramsOfNoRealTaskModifyDialog1 = this.paramsOfNoRealTaskModifyDialog1;
      this.$refs.modifyNoRealTaskDialog1.bindValidateOfModifyDialog1();
      this.$refs.modifyTaskDialog2.close();
      this.$refs.modifyTaskDialog1.show();
    },

    // 完成修改非实时任务
    async completeModifyNoRealTask(){
      this.paramsOfNoRealTaskModifyDialog2 = this.$refs.modifyNoRealTaskDialog2.paramsOfNoRealTaskModifyDialog2;
      const counterIdList = this.paramsOfNoRealTaskModifyDialog2.counterIdList.map(function (counterId) {
        const index = counterId.search(/[1-9]/);
        return counterId.slice(index);
      });
      const counterObjList = this.$refs.modifyNoRealTaskDialog2.treeGridList.filter(function (counterObj) {
        return counterObj.parentItem != null;
      }).map(function (counterObj) {
        return {
          counterName: counterObj.counterName,
          counterCode: counterObj.id,
          measureObjName: counterObj.measureObjName,
          taskMeasureObjCode: counterObj.parentItem
        }
      });
      this.$loading.showLoadding(this.$t('System.loading'));

      await this.$axios.post('/lte/ems/pm/noReal/task/modifyNoRealTask.html', {
        taskId: this.editTaskId,
        taskName: this.paramsOfNoRealTaskModifyDialog1.taskName,
        taskDepict: this.paramsOfNoRealTaskModifyDialog1.taskDepict,
        neType: parseInt(this.paramsOfNoRealTaskModifyDialog1.neType),
        sampleTime: parseInt(this.paramsOfNoRealTaskModifyDialog1.sampleTime),
        reportTime: parseInt(this.paramsOfNoRealTaskModifyDialog1.reportTime),
        startTime: parseInt(this.paramsOfNoRealTaskModifyDialog1.startTime == null ? '0' : this.paramsOfNoRealTaskModifyDialog1.startTime.getTime() / 1000),
        endTime: parseInt(this.paramsOfNoRealTaskModifyDialog1.endTime == null ? '0' : this.paramsOfNoRealTaskModifyDialog1.endTime.getTime() / 1000),
        startHour: parseInt(this.paramsOfNoRealTaskModifyDialog1.startHour),
        endHour: parseInt(this.paramsOfNoRealTaskModifyDialog1.endHour),
        week: this.paramsOfNoRealTaskModifyDialog1.week.join(),
        day: this.paramsOfNoRealTaskModifyDialog1.day.join(),
        neId: parseInt(this.paramsOfNoRealTaskModifyDialog2.neId),
        counterIdNum: parseInt(this.paramsOfNoRealTaskModifyDialog2.counterIdNum),
        counterIdList: counterIdList.join(),
        counterObjList: JSON.stringify(counterObjList)
      }).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode.toUpperCase() != 'SUCCESS') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.modify')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmNoRealTaskRightListContent.getTaskListOfPmNoReal();
        this.$parent.$parent.$refs.PmNoRealTaskLeftTree.$refs.PmNoRealTaskResourceTreePage.getNeTree();
      });
      this.$loading.hideLoadding();
      this.$refs.modifyTaskDialog2.close();
    },

    closeUploadNoRealTaskDialog(){
      this.$refs.uploadTaskDialog.close();
    },

    async uploadNoRealTask(){
      const data = this.$refs.pmNoRealTaskRightListContent.rowDataOfPmNoRealTaskList;

      let startTime = this.$refs.uploadNoRealTaskDialog.startTime.getTime() / 1000;
      let endTime = this.$refs.uploadNoRealTaskDialog.endTime.getTime() / 1000;

      if(startTime > endTime){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.startCannotLaterThanEnd') });
        return;
      }

      if(data.startTime != null && data.startTime > startTime){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.startCannotEarlierThanTaskStart') });
        return;
      }
      if(data.endTime != null && data.endTime < endTime){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.endCannotLaterThanTaskEnd') });
        return;
      }

      console.log("endTime", endTime);
      console.log("currentTime", new Date().getTime()/1000);
      if(endTime > new Date().getTime() / 1000){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.timeShouldEarlierThanCurrent') });
        return;
      }

      this.$loading.showLoadding(this.$t('System.loading'));
      await this.$axios.post('/lte/ems/pm/noReal/task/uploadNoRealTask.html', {
        neType: parseInt(this.uploadGridClickData.neType),
        neId: parseInt(this.uploadGridClickData.neId),
        taskId: parseInt(this.uploadGridClickData.taskId),
        startTime: startTime,
        endTime: endTime,
      }).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode.toUpperCase() != 'SUCCESS') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: `${this.$t('Pm.uploadTask')}${this.$t('Pm.success')}` });
        }
        this.$refs.pmNoRealTaskRightListContent.getTaskListOfPmNoReal();
        this.$parent.$parent.$refs.PmNoRealTaskLeftTree.$refs.PmNoRealTaskResourceTreePage.getNeTree();
      });
      this.$refs.uploadTaskDialog.close();
      this.$loading.hideLoadding();
    }
  },
  watch: {
  }
};
</script>

<style>
</style>
